module.exports = __webpack_public_path__ + "static/pricingHeadwinds-a066acf3dff0107f2df17add15f89f72.png";